<template>
  <div>
    <div v-if="enterprise" class="mb-10">
      <back-button :backURL="backURL" :title="title" />
    </div>
    <v-skeleton-loader v-else max-width="300px" type="text"></v-skeleton-loader>

    <div v-if="windowWidth <= 768 && enterprise">
      <v-bottom-navigation grow v-model="bottomNav">
        <router-link v-for="button in firstRowBtns" tag="v-btn" :key="button.name"
          :to="{ name: buildRoute(button.route) }">
          <span>{{ button.title }}</span>
          <v-icon>{{ button.icon }}</v-icon>
        </router-link>
      </v-bottom-navigation>
      <v-bottom-navigation grow v-model="bottomNav2">
        <router-link v-for="button in secondRowBtns" tag="v-btn" :key="button.name"
          :to="{ name: buildRoute(button.route) }">
          <span>{{ button.title }}</span>
          <v-icon>{{ button.icon }}</v-icon>
        </router-link>
      </v-bottom-navigation>
    </div>
    <div v-else-if="windowWidth >= 768 && enterprise">
      <v-bottom-navigation grow v-model="bottomNav">
        <router-link v-for="button in desktopNav" tag="v-btn" :key="button.name"
          :to="{ name: buildRoute(button.route) }">
          <span>{{ button.title }}</span>
          <v-icon>{{ button.icon }}</v-icon>
        </router-link>
      </v-bottom-navigation>
    </div>
    <v-skeleton-loader v-else class="mx-auto mb-10" type="image"></v-skeleton-loader>
    <transition name="fade" mode="out-in">
      <router-view v-if="enterprise" class="mb-10" />
      <v-skeleton-loader v-else class="mx-auto mb-10" type="image"></v-skeleton-loader>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BackButton from '~/components/BackButton';

export default {
  name: 'EnterpriseProfile',
  metaInfo() {
    return { title: this.$t('enterprises') };
  },
  props: {
    dealerId: { required: false },
    id: { required: true },
  },
  components: {
    BackButton,
  },
  computed: {
    enterprise() {
      return this.$store.state.profile.enterprise;
    },
    windowWidth() {
      return this.$store.state.window.width;
    },
    desktopNav() {
      return this.firstRowBtns.concat(this.secondRowBtns);
    },
    title() {
      return `Empresa <b>${this.enterprise.name}</b> - R.U.C. ${this.enterprise.ruc} - Sucursal ${this.enterprise.branch_code}`;
    },
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  data: () => ({
    bottomNav: 'profileEnterprise',
    bottomNav2: '',
    backURL: 'enterprises',
    firstRowBtns: [
      {
        route: 'enterprise.profileEnterprise',
        name: 'profileEnterprise',
        title: 'Perfil',
        icon: 'mdi-account',
      },
      {
        route: 'enterprise.licences',
        name: 'licences',
        title: 'Licencias',
        icon: 'mdi-credit-card',
      },
      {
        route: 'enterprise.devices',
        name: 'devices',
        title: 'Dispositivos',
        icon: 'mdi-cellphone',
      },
      {
        route: 'enterprise.users',
        name: 'users',
        title: 'Usuarios',
        icon: 'mdi-account-key',
      },
      {
        route: 'enterprise.integration',
        name: 'integration',
        title: 'Integración',
        icon: 'mdi-account-key',
      },
      {
        route: 'enterprise.subsidiaries',
        name: 'subsidiaries',
        title: 'Sucursales',
        icon: 'fas fa-city',
      },
      {
        route: 'enterprise.documents',
        name: 'documents',
        title: 'Documentos',
        icon: 'mdi-file',
      },
    ],
    secondRowBtns: [
      {
        route: 'enterprise.partners',
        name: 'partners',
        title: 'Asociados',
        icon: 'mdi-account-multiple',
      },
      {
        route: 'enterprise.others',
        name: 'otros',
        title: 'Otros',
        icon: 'mdi-plus',
      },
      {
        route: 'enterprise.membership',
        name: 'membership',
        title: 'Afiliación',
        icon: 'mdi-qrcode',
      },
      {
        route: 'enterprise.consumption',
        name: 'consumption',
        title: 'Reporte Consumo',
        icon: 'mdi-tray-full',
      },
    ],
    enterprises_config: null,
    loading_config: true,
  }),
  methods: {
    buildRoute(route) {
      if (this.dealerId) {
        return `dealers.${route}`;
      }
      return route;
    },
    getConfigEnterprise() {
      const url = `/api/catalogs/dealers/${this.user.dealer_id}/getConfig`;
      return window.axios.get(url);
    },
  },
  created() {
    this.$store.dispatch('profile/resetEnterprise');
  },
  async mounted() {
    try {
      const response = await this.getConfigEnterprise();
      this.enterprises_config = parseInt(response.data.enterprises_config ?? response.data, 10);
    } catch (e) {
      this.enterprises_config = 0; // o lo que decidas por defecto
    } finally {
      this.loading_config = false; // ya terminó de cargar
    }
    window.axios.get(`/api/enterprises/${this.id}`)
      .then((result) => {
        this.$store.dispatch('profile/setCurrentEnterprise', { enterprise: result.data });
        if (this.enterprises_config !== 1) {
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'integration'), 1);
        }
        if (this.enterprise.type === 3) {
          this.firstRowBtns.push({
            route: 'enterprise.certificates.pac',
            name: 'certificates',
            title: 'Certificados',
            icon: 'mdi-certificate',
          });
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'subsidiaries'), 1);
        }
        if (this.enterprise.type === 1) {
          this.firstRowBtns.push({
            route: 'enterprise.certificates.fel',
            name: 'certificates',
            title: 'Certificados',
            icon: 'mdi-certificate',
          });
          this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'partners'), 1);
        }
        if (this.enterprise.type === 2) {
          this.firstRowBtns.push({
            route: 'enterprise.certificates.fel',
            name: 'certificates',
            title: 'Certificados',
            icon: 'mdi-certificate',
          });
        }
        if (this.enterprise.type === 3) {
          this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'otros'), 1);
        }
        if (this.enterprise.type === null) {
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'licences'), 1);
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'devices'), 1);
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'users'), 1);
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'subsidiaries'), 1);
          this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'documents'), 1);
          this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'partners'), 1);
          this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'otros'), 1);
          this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'membership'), 1);
        } else {
          if (!this.can('licencias_empresa')) {
            this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'licences'), 1);
          }
          if (!this.can('dispositivos_empresa')) {
            this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'devices'), 1);
          }
          if (!this.can('usuarios_empresa')) {
            this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'users'), 1);
          }
          if (!this.can('documentos_empresa')) {
            this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'documents'), 1);
          }
          if (!this.can('certificados_empresa')) {
            this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'certificates'), 1);
          }
          if (!this.can('otros_empresa')) {
            this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'others'), 1);
          }
          if (!this.can('afiliacion_empresa')) {
            this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'membership'), 1);
          }
          if (!this.can('reporte_consumo')) {
            this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'consumption'), 1);
          }
          if (this.enterprise.type === 1 || this.enterprise.type === 2) {
            if (!this.can('sucursal_empresa')) { // FEL PURO
              this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'subsidiaries'), 1);
            }
          }
          if (this.enterprise.type === 3 || this.enterprise.type === 2) {
            if (!this.can('asociados_empresa')) { // PAC PURO
              this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'partners'), 1);
            }
          }
        }
        if (this.enterprise.receptor_id != null && this.can('usuarios_empresa') && (this.enterprise.type === null || this.enterprise.type === 0)) {
          this.secondRowBtns.push({
            route: 'enterprise.users',
            name: 'users',
            title: 'Usuarios',
            icon: 'mdi-account-key',
          });
        }
      })
      .catch((error) => {
        this.$router.push({ path: '/404' });
        this.$store.dispatch('notifications/show', {
          message: error.response.data.message,
          type: error.response.data.type,
        });
      });
  },
};
</script>
